(function () {
  'use strict';

  var DRAG_THRESHOLD = 5;

  /* ============================================================
   * Filter-Leiste: Drag-to-Scroll, Wheel→horizontal, Snap, Fades
   * ============================================================ */

  function initFilterBar(wrap) {
    var list = wrap.querySelector('.rf-blog-magazine__filters');
    if (!list) return;

    function updateOverflow() {
      var canLeft = list.scrollLeft > 1;
      var canRight = list.scrollLeft + list.clientWidth < list.scrollWidth - 1;
      var hasOverflow = list.scrollWidth > list.clientWidth + 1;
      wrap.setAttribute('data-can-scroll-left', canLeft ? 'true' : 'false');
      wrap.setAttribute('data-can-scroll-right', canRight ? 'true' : 'false');
      wrap.setAttribute('data-overflow', hasOverflow ? 'true' : 'false');
    }

    updateOverflow();
    list.addEventListener('scroll', updateOverflow, { passive: true });
    window.addEventListener('resize', updateOverflow);

    var active = list.querySelector('.rf-blog-magazine__filter.is-active');
    if (active) {
      var ll = list.getBoundingClientRect();
      var al = active.getBoundingClientRect();
      var offset = active.offsetLeft - list.clientWidth / 2 + active.offsetWidth / 2;
      if (offset > 0 && al.right > ll.right) {
        list.scrollLeft = offset;
      }
    }

    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScroll = 0;

    function pointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      isDown = true;
      didDrag = false;
      startX = e.touches ? e.touches[0].pageX : e.pageX;
      startScroll = list.scrollLeft;
    }

    function pointerMove(e) {
      if (!isDown) return;
      var x = e.touches ? e.touches[0].pageX : e.pageX;
      var dx = x - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) {
        if (!didDrag) {
          didDrag = true;
          list.classList.add('is-dragging');
        }
        list.scrollLeft = startScroll - dx;
        if (e.cancelable && e.type === 'mousemove') e.preventDefault();
      }
    }

    function pointerUp(e) {
      if (!isDown) return;
      isDown = false;
      if (didDrag) {
        if (e && e.cancelable) e.preventDefault();
        setTimeout(function () {
          list.classList.remove('is-dragging');
        }, 0);
      }
    }

    list.addEventListener('mousedown', pointerDown);
    document.addEventListener('mousemove', pointerMove);
    document.addEventListener('mouseup', pointerUp);
    list.addEventListener('mouseleave', function () {
      isDown = false;
    });

    list.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    list.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          if (list.scrollWidth <= list.clientWidth) return;
          list.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      },
      { passive: false }
    );
  }

  /* ============================================================
   * Load-More: nutzt Shopify Section Rendering API
   * ============================================================ */

  function setLoading(button, isLoading) {
    if (!button) return;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    var spinner = button.querySelector('.rf-blog-magazine__spinner');
    if (spinner) {
      if (isLoading) spinner.removeAttribute('hidden');
      else spinner.setAttribute('hidden', '');
    }
  }

  function fetchPage(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(
      function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      }
    );
  }

  function appendToUrl(url, params) {
    var hashIndex = url.indexOf('#');
    var hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
    var base = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    var pairs = [];
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k)) {
        pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
      }
    }
    return base + sep + pairs.join('&') + hash;
  }

  function initLoadMore(wrap) {
    var grid = wrap.parentElement && wrap.parentElement.querySelector('[data-rf-grid]');
    if (!grid) {
      grid = document.querySelector('[data-rf-grid]');
    }
    if (!grid) return;

    var button = wrap.querySelector('[data-rf-load-more-button]');
    if (!button) return;

    var sectionId = wrap.getAttribute('data-section-id');

    button.addEventListener('click', function (e) {
      e.preventDefault();

      var nextUrl = wrap.getAttribute('data-next-url');
      if (!nextUrl) return;

      setLoading(button, true);

      var fetchUrl = appendToUrl(nextUrl, { section_id: sectionId });

      fetchPage(fetchUrl)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newGrid = doc.querySelector('[data-rf-grid]');
          if (newGrid) {
            var items = newGrid.querySelectorAll('.rf-blog-magazine__grid-item');
            for (var i = 0; i < items.length; i++) {
              grid.appendChild(items[i]);
            }
          }

          var newWrap = doc.querySelector('[data-rf-load-more]');
          if (newWrap && newWrap.getAttribute('data-next-url')) {
            wrap.setAttribute('data-next-url', newWrap.getAttribute('data-next-url'));
            button.setAttribute('href', newWrap.getAttribute('data-next-url'));
            setLoading(button, false);
          } else {
            wrap.parentNode.removeChild(wrap);
          }
        })
        .catch(function () {
          setLoading(button, false);
          window.location.href = wrap.getAttribute('data-next-url');
        });
    });
  }

  /* ============================================================
   * Init
   * ============================================================ */

  function initAll(root) {
    var scope = root || document;
    var bars = scope.querySelectorAll('[data-rf-filter-bar]');
    for (var i = 0; i < bars.length; i++) initFilterBar(bars[i]);

    var loaders = scope.querySelectorAll('[data-rf-load-more]');
    for (var j = 0; j < loaders.length; j++) initLoadMore(loaders[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
